import classnames from "classnames";
import { isNotPresent } from "neetocist";
import { Typography } from "neetoui";
import PropTypes from "prop-types";

const CardLayout = ({
  className = "",
  icon,
  containerClassName = "",
  title = null,
  description = null,
  actionBlock,
  children,
}) => (
  <div
    data-testid="neeto-molecules-card-container"
    className={classnames([
      "neeto-molecules-card__container mx-auto w-full max-w-3xl",
      containerClassName,
    ])}
  >
    <div
      data-testid="neeto-molecules-card"
      className={classnames([
        "neeto-molecules-card neeto-ui-border-gray-300 neeto-ui-rounded-lg my-6 w-full border",
        className,
      ])}
    >
      <div className="neeto-molecules-card__content p-4 md:p-6">
        {icon && (
          <div className="neeto-molecules-card__icon-wrapper mb-4 w-full text-start">
            {icon}
          </div>
        )}
        {title && (
          <Typography
            style="h2"
            className={classnames([
              "mb-2",
              { "pb-2": isNotPresent(description) },
            ])}
          >
            {title}
          </Typography>
        )}
        {description && (
          <Typography className="mb-4" style="body1">
            {description}
          </Typography>
        )}
        {children}
      </div>
      {actionBlock && (
        <div
          className={classnames([
            "neeto-molecules-card__action-block neeto-ui-bg-gray-50 neeto-ui-rounded-lg sticky bottom-0 w-full rounded-t-none p-4 md:px-6",
            className,
          ])}
        >
          {actionBlock}
        </div>
      )}
    </div>
  </div>
);

CardLayout.propTypes = {
  /**
   * To set the title of the card.
   */
  title: PropTypes.string,
  /**
   * To set the description of the card.
   */
  description: PropTypes.node,
  /**
   * To set custom class name to the card.
   */
  className: PropTypes.string,
  /**
   * To set custom class name to the card container.
   */
  containerClassName: PropTypes.string,
  /**
   * To specify the content to be rendered in the card footer.
   */
  actionBlock: PropTypes.node,
  /**
   * To specify the components to be rendered inside the card.
   */
  children: PropTypes.node,
  /**
   * To set the icon of the card.
   */
  icon: PropTypes.node,
};

export default CardLayout;
